// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditPopup_deleteButton__VHNTe","field":"EditPopup_field__17ibP","text":"EditPopup_text__sarMJ"};